import { ValueOf } from "@vy/utils";
import type { AutocompleteInputChangeReason } from "@mui/material";

export const INPUT_REASONS = {
    INPUT: 'input',
    CLEAR: 'clear',
} as const;

export type InputReason = ValueOf<typeof INPUT_REASONS>;

export const INPUT_REASONS_VALUES: AutocompleteInputChangeReason[] = Object.values(INPUT_REASONS);